// Safeguard Assignment Module
window.safeguardAssignment = {
    
    // Helper function to get the appropriate nonce
    getNonce: function() {
        // Try to get the safeguard assignment nonce first
        let nonce = window.safeguardAssignmentData?.nonce || 
                   window.controlsData?.safeguard_assignment_nonce ||
                   window.evidenceData?.safeguard_assignment_nonce;
        
        // If not found, fall back to the general nonce
        if (!nonce) {
            nonce = window.controlsData?.nonce || window.evidenceData?.nonce;
        }
        
        return nonce;
    },
    
    // Helper function to get nonce for specific actions
    getNonceForAction: function(action) {
        console.log(`getNonceForAction called for action: ${action}`);
        console.log('Available nonce sources:');
        console.log('- window.evidenceData?.projectData_nonce:', window.evidenceData?.projectData_nonce);
        console.log('- window.controlsData?.nonce:', window.controlsData?.nonce);
        console.log('- window.safeguardAssignmentData?.nonce:', window.safeguardAssignmentData?.nonce);
        console.log('- window.controlsData?.safeguard_assignment_nonce:', window.controlsData?.safeguard_assignment_nonce);
        console.log('- window.evidenceData?.safeguard_assignment_nonce:', window.evidenceData?.safeguard_assignment_nonce);
        
        switch(action) {
            case 'get_corporate_users':
            case 'get_assignment_users':
                const corporateUsersNonce = window.evidenceData?.projectData_nonce || window.controlsData?.nonce;
                console.log(`getNonceForAction: ${action} -> ${corporateUsersNonce}`);
                return corporateUsersNonce;
            case 'get_all_evidence_posts':
                const evidencePostsNonce = window.evidenceData?.projectData_nonce || window.controlsData?.nonce;
                console.log(`getNonceForAction: get_all_evidence_posts -> ${evidencePostsNonce}`);
                return evidencePostsNonce;
            case 'safeguard_assignment':
                const safeguardAssignmentNonce = window.safeguardAssignmentData?.nonce || 
                       window.controlsData?.safeguard_assignment_nonce ||
                       window.evidenceData?.safeguard_assignment_nonce;
                console.log(`getNonceForAction: safeguard_assignment -> ${safeguardAssignmentNonce}`);
                return safeguardAssignmentNonce;
            default:
                const defaultNonce = this.getNonce();
                console.log(`getNonceForAction: default -> ${defaultNonce}`);
                return defaultNonce;
        }
    },
    
    // Initialize the safeguard assignment functionality
    init: function() {
        this.attachEventListeners();
        this.addStyles();
        this.createModal();
    },
    
    // Attach click event listeners to safeguard assignment buttons (only once; init() runs on DOMContentLoaded and controlsAppended)
    attachEventListeners: function() {
        if (this._delegationAttached) {
            return;
        }
        this._delegationAttached = true;
        // Use event delegation to handle dynamically added buttons
        document.addEventListener('click', (event) => {
            if (event.target.closest('.safeguard-assignment-btn')) {
                this.handleSafeguardAssignmentClick(event);
            }
            if (event.target.closest('.view-assignments-btn')) {
                this.handleViewAssignmentsClick(event);
            }
            if (event.target.closest('.remove-assignment-btn')) {
                this.handleRemoveAssignmentClick(event);
            }
        });
    },
    
    // Handle click events on safeguard assignment buttons
    handleSafeguardAssignmentClick: function(event) {
        event.preventDefault();
        
        const button = event.target.closest('.safeguard-assignment-btn');
        const controlId = button.getAttribute('data-control-id');
        
        console.log('Safeguard assignment clicked for control ID:', controlId);
        
        // Store the control ID for use in the modal
        this.currentControlId = controlId;
        
        // Update the modal title to include the safeguard ID
        this.updateModalTitle(controlId);
        
        // Show the modal
        this.showModal();
        
        // Load both evidence posts and corporate users by default
        this.loadEvidencePosts();
        this.loadCorporateUsers();
        
        // Load existing assignments for this safeguard
        this.loadExistingAssignments();
    },
    
    // Handle click events on view assignments buttons
    handleViewAssignmentsClick: function(event) {
        event.preventDefault();
        
        const button = event.target.closest('.view-assignments-btn');
        const controlId = button.getAttribute('data-control-id');
        
        console.log('View assignments clicked for control ID:', controlId);
        
        this.currentControlId = controlId;
        this.updateAssignmentsModalTitle(controlId);
        this.showAssignmentsModal();
        this.loadAssignments();
    },
    
    // Handle click events on remove assignment buttons
    handleRemoveAssignmentClick: function(event) {
        event.preventDefault();
        
        const button = event.target.closest('.remove-assignment-btn');
        const projectId = button.getAttribute('data-project-id');
        const safeguardId = button.getAttribute('data-safeguard-id');
        const evidenceId = button.getAttribute('data-evidence-id');
        const assignedTo = button.getAttribute('data-assigned-to');
        
        if (confirm('Are you sure you want to remove this assignment?')) {
            this.removeAssignment(projectId, safeguardId, evidenceId, assignedTo);
        }
    },
    
    // Use the safeguard assignment modal from the DOM (template-parts/modals/assessments/safeguard-assessments.php).
    // Initializes Bootstrap and attaches event listeners only once.
    createModal: function() {
        const modalEl = document.getElementById('safeguardAssignmentModal');
        if (!modalEl) {
            return;
        }
        if (typeof bootstrap !== 'undefined') {
            this.modal = new bootstrap.Modal(modalEl);
        } else {
            console.error('Bootstrap is not available for modal initialization');
        }
        // Attach listeners only once (init() can run multiple times via DOMContentLoaded and controlsAppended)
        this.attachModalEventListeners();
    },

    // Use the assignments view modal from the DOM (template-parts/modals/assessments/safeguard-assessments.php).
    createAssignmentsModal: function() {
        const modalEl = document.getElementById('assignmentsViewModal');
        if (!modalEl) {
            return;
        }
        if (typeof bootstrap !== 'undefined') {
            this.assignmentsModal = new bootstrap.Modal(modalEl);
        } else {
            console.error('Bootstrap is not available for modal initialization');
        }
    },
    
    // Attach event listeners to modal elements (only once; init() can run multiple times)
    attachModalEventListeners: function() {
        const form = document.getElementById('safeguardAssignmentForm');
        if (!form || form.dataset.safeguardListeners === 'attached') {
            return;
        }
        form.dataset.safeguardListeners = 'attached';

        const evidenceSelect = document.getElementById('evidenceSelect');
        const userSelect = document.getElementById('userSelect');
        const assignBtn = document.getElementById('assignSafeguardBtn');
        const addAnotherBtn = document.getElementById('addAnotherAssignmentBtn');
        if (!evidenceSelect || !userSelect || !assignBtn || !addAnotherBtn) {
            return;
        }

        // Evidence selection change
        evidenceSelect.addEventListener('change', (event) => {
            this.clearValidationErrors();
            this.updateAssignButton();
        });
        
        // User selection change
        userSelect.addEventListener('change', (event) => {
            this.clearValidationErrors();
            this.updateAssignButton();
        });
        
        // Assign button click
        assignBtn.addEventListener('click', () => {
            this.assignSafeguard();
        });
        
        // Add another assignment button
        addAnotherBtn.addEventListener('click', () => {
            this.addAnotherAssignmentRow();
        });
    },
    
    // Update the modal title to include the safeguard ID
    updateModalTitle: function(controlId) {
        const modalTitle = document.getElementById('safeguardAssignmentModalLabel');
        if (modalTitle) {
            modalTitle.textContent = `Assign Safeguard "${controlId}" to Evidence`;
            console.log('Modal title updated to:', modalTitle.textContent);
        } else {
            console.warn('Modal title element not found');
        }
    },
    
    // Update the assignments modal title to include the safeguard ID
    updateAssignmentsModalTitle: function(controlId) {
        const modalTitle = document.getElementById('assignmentsViewModalLabel');
        if (modalTitle) {
            modalTitle.textContent = `Safeguard ${controlId} Assignments`;
            console.log('Assignments modal title updated to:', modalTitle.textContent);
        } else {
            console.warn('Assignments modal title element not found');
        }
    },
    
    // Show the modal
    showModal: function() {
        if (this.modal) {
            // Clear any existing data immediately before showing the modal
            this.clearExistingAssignments();
            
            // Show the loading overlay
            const loadingOverlay = document.getElementById('modalLoadingOverlay');
            if (loadingOverlay) {
                loadingOverlay.style.setProperty('display', 'flex', 'important');
            }
            
            this.modal.show();
            console.log('Modal shown');
            
            // Debug: Check if the existing assignments section exists
            const existingSection = document.getElementById('existingAssignmentsSection');
            console.log('Modal shown - Existing assignments section:', existingSection);
            if (existingSection) {
                console.log('Modal shown - Section display style:', existingSection.style.display);
                console.log('Modal shown - Section computed style:', window.getComputedStyle(existingSection).display);
            }
        } else {
            console.error('Modal not initialized');
        }
    },
    
    // Show the assignments modal
    showAssignmentsModal: function() {
        if (!this.assignmentsModal) {
            this.createAssignmentsModal();
        }
        this.assignmentsModal.show();
    },
    
    // Load evidence posts for the current user
    loadEvidencePosts: function() {
        const evidenceSelect = document.getElementById('evidenceSelect');
        
        // Clear existing options
        evidenceSelect.innerHTML = '<option value="">Choose evidence...</option>';
        
        // Get current user ID from controlsData
        const currentUserId = window.controlsData?.current_user_id;
        
        console.log('=== LOADING EVIDENCE POSTS ===');
        console.log('Loading evidence posts for user ID:', currentUserId);
        console.log('controlsData available:', window.controlsData);
        console.log('evidenceData available:', window.evidenceData);
        
        const nonce = this.getNonceForAction('get_all_evidence_posts');
        console.log('Nonce for get_all_evidence_posts:', nonce);
        
        // Check if we have the required data
        if (!currentUserId) {
            console.error('Current user ID is missing');
            this.showNotification('User authentication error', 'danger');
            return;
        }
        
        if (!window.controlsData?.ajax_url) {
            console.error('AJAX URL is missing');
            this.showNotification('Configuration error', 'danger');
            return;
        }
        
        if (!nonce) {
            console.error('Nonce is missing for get_all_evidence_posts');
            this.showNotification('Security check failed - missing nonce', 'danger');
            return;
        }
        
        const requestData = {
            action: 'get_all_evidence_posts',
            user_id: currentUserId,
            nonce: nonce
        };
        
        console.log('Request data:', requestData);
        
        jQuery.ajax({
            url: window.controlsData?.ajax_url,
            type: 'POST',
            data: requestData,
            success: (response) => {
                if (response.success && response.data) {
                    response.data.forEach(post => {
                        const option = document.createElement('option');
                        option.value = post.slug; // Use slug instead of ID
                        option.textContent = `${post.title} (${post.date})`;
                        evidenceSelect.appendChild(option);
                    });
                } else {
                    console.error('Failed to load evidence posts:', response);
                    this.showNotification('Failed to load evidence posts', 'danger');
                }
            },
            error: (xhr, status, error) => {
                console.error('AJAX error loading evidence posts:', error);
                this.showNotification('Error loading evidence posts', 'danger');
            }
        });
    },
    
    // Load corporate users
    loadCorporateUsers: function() {
        const userSelect = document.getElementById('userSelect');
        
        // Clear existing options
        userSelect.innerHTML = '<option value="">Choose user...</option>';
        
        // Get current user ID from controlsData
        const currentUserId = window.controlsData.current_user_id;
        
        // Get evidence ID if we're in an evidence context
        const evidenceId = this.getEvidenceIdFromContext();
        
        const requestData = {
            action: 'get_assignment_users',
            user_id: currentUserId,
            nonce: this.getNonceForAction('get_assignment_users')
        };
        
        // Add evidence_id if available
        if (evidenceId) {
            requestData.evidence_id = evidenceId;
        }
        
        jQuery.ajax({
            url: window.controlsData.ajax_url,
            type: 'POST',
            data: requestData,
            success: (response) => {
                if (response.success && response.data) {
                    response.data.forEach(user => {
                        const option = document.createElement('option');
                        option.value = user.id;
                        option.textContent = `${user.name} (${user.email})`;
                        userSelect.appendChild(option);
                    });
                } else {
                    console.error('Failed to load corporate users:', response);
                    this.showNotification('Failed to load corporate users', 'danger');
                }
            },
            error: (xhr, status, error) => {
                console.error('AJAX error loading corporate users:', error);
                this.showNotification('Error loading corporate users', 'danger');
            }
        });
    },
    
    // Load existing assignments for the current safeguard
    loadExistingAssignments: function() {
        const projectSlug = this.getProjectSlug();
        const controlId = this.currentControlId;
        
        console.log('Loading existing assignments for project:', projectSlug, 'safeguard:', controlId);
        
        if (!projectSlug || !controlId) {
            console.error('Missing project slug or control ID for loading existing assignments');
            // Hide the loading overlay and show the form
            const loadingOverlay = document.getElementById('modalLoadingOverlay');
            if (loadingOverlay) {
                loadingOverlay.style.setProperty('display', 'none', 'important');
            }
            
            // Set title for new assignment (fallback)
            const modalTitle = document.getElementById('safeguardAssignmentModalLabel');
            if (modalTitle && controlId) {
                modalTitle.textContent = `Assign Safeguard "${controlId}" to Evidence`;
            }
            
            // Show the form and main assignment row if we can't load existing assignments
            const safeguardAssignmentForm = document.getElementById('safeguardAssignmentForm');
            if (safeguardAssignmentForm) {
                safeguardAssignmentForm.style.display = 'block';
            }
            const mainAssignmentRow = document.getElementById('mainAssignmentRow');
            if (mainAssignmentRow) {
                mainAssignmentRow.style.display = 'flex';
            }
            return;
        }
        
        // Note: We don't show the existing assignments section here anymore
        // since we have the full modal loading overlay. The section will only
        // be shown if there are actual existing assignments to display.
        
        // Get AJAX URL from available data sources
        const ajaxUrl = window.controlsData?.ajax_url || window.evidenceData?.ajax_url;
        
        if (!ajaxUrl) {
            console.error('No AJAX URL found for loadExistingAssignments');
            this.showNotification('Error: AJAX URL not available', 'danger');
            return;
        }
        
        jQuery.ajax({
            url: ajaxUrl,
            type: 'POST',
            data: {
                action: 'safeguard_assignment',
                subaction: 'get_assignments',
                nonce: this.getNonceForAction('safeguard_assignment'),
                projectId: projectSlug,
                safeguardId: controlId
            },
            success: (response) => {
                if (response.success && response.data) {
                    console.log('Existing assignments loaded:', response.data);
                    this.populateExistingAssignments(response.data);
                } else {
                    console.log('No existing assignments found or error:', response);
                    // Populate with empty array to trigger proper handling
                    this.populateExistingAssignments([]);
                }
            },
            error: (xhr, status, error) => {
                console.error('AJAX error loading existing assignments:', error);
                this.showNotification('Error loading existing assignments', 'danger');
                
                // Hide the loading overlay and show the form
                const loadingOverlay = document.getElementById('modalLoadingOverlay');
                if (loadingOverlay) {
                    loadingOverlay.style.setProperty('display', 'none', 'important');
                }
                
                // Set title for new assignment (fallback)
                const modalTitle = document.getElementById('safeguardAssignmentModalLabel');
                const controlId = this.currentControlId;
                if (modalTitle && controlId) {
                    modalTitle.textContent = `Assign Safeguard "${controlId}" to Evidence`;
                }
                
                // Show the form and main assignment row if there's an error loading existing assignments
                const safeguardAssignmentForm = document.getElementById('safeguardAssignmentForm');
                if (safeguardAssignmentForm) {
                    safeguardAssignmentForm.style.display = 'block';
                }
                const mainAssignmentRow = document.getElementById('mainAssignmentRow');
                if (mainAssignmentRow) {
                    mainAssignmentRow.style.display = 'flex';
                }
            }
        });
    },
    
    // Populate existing assignments in the modal
    populateExistingAssignments: function(assignments) {
        // Hide the loading overlay
        const loadingOverlay = document.getElementById('modalLoadingOverlay');
        if (loadingOverlay) {
            loadingOverlay.style.setProperty('display', 'none', 'important');
        }
        
        // Update modal title based on whether there are existing assignments
        const modalTitle = document.getElementById('safeguardAssignmentModalLabel');
        const controlId = this.currentControlId;
        
        if (!assignments || assignments.length === 0) {
            console.log('No existing assignments to populate');
            // Set title for new assignment
            if (modalTitle && controlId) {
                modalTitle.textContent = `Assign Safeguard "${controlId}" to Evidence`;
            }
            
            // Show the form now that loading is complete
            const safeguardAssignmentForm = document.getElementById('safeguardAssignmentForm');
            if (safeguardAssignmentForm) {
                safeguardAssignmentForm.style.display = 'block';
            }
            
            // Show main assignment row when no existing assignments
            const mainAssignmentRow = document.getElementById('mainAssignmentRow');
            if (mainAssignmentRow) {
                mainAssignmentRow.style.display = 'flex';
            }
            // Update button text to "Add Another Assignment"
            const addAnotherBtn = document.getElementById('addAnotherAssignmentBtn');
            if (addAnotherBtn) {
                addAnotherBtn.innerHTML = '<i class="fas fa-plus"></i> Add Another Assignment';
            }
            return;
        }
        
        // Set title for existing assignments view
        if (modalTitle && controlId) {
            modalTitle.textContent = `Safeguard Assignments (${controlId})`;
        }
        
        // Show the form now that loading is complete
        const safeguardAssignmentForm = document.getElementById('safeguardAssignmentForm');
        if (safeguardAssignmentForm) {
            safeguardAssignmentForm.style.display = 'block';
        }
        
        console.log('Populating existing assignments:', assignments);
        
        // Show the existing assignments section since we have assignments
        const existingSection = document.getElementById('existingAssignmentsSection');
        const existingList = document.getElementById('existingAssignmentsList');
        
        if (existingSection) {
            existingSection.style.setProperty('display', 'block', 'important');
            existingSection.classList.remove('d-none');
            existingSection.classList.add('d-block');
            console.log('Populating assignments - Section made visible');
        }
        
        // Clear the existing list
        existingList.innerHTML = '';
        
        // Show/hide main assignment row based on existing assignments
        const mainAssignmentRow = document.getElementById('mainAssignmentRow');
        const addAnotherBtn = document.getElementById('addAnotherAssignmentBtn');
        
        // Create table structure for existing assignments
        let tableHTML = `
            <div class="table-responsive">
                <table class="table mb-0">
                    <thead>
                        <tr>
                            <th>Assigned To</th>
                            <th>Evidence</th>
                            <th class="text-center">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
        `;
        
        assignments.forEach((assignment, index) => {
            tableHTML += this.generateExistingAssignmentRow(assignment, index);
        });
        
        tableHTML += `
                    </tbody>
                </table>
            </div>
        `;
        
        existingList.innerHTML = tableHTML;
        
        // Attach event listeners for remove buttons
        this.attachExistingAssignmentEventListeners();
        
        // Hide main assignment row when existing assignments are present
        if (mainAssignmentRow) {
            mainAssignmentRow.style.display = 'none';
        }
        // Update button text to "Add Assignment"
        if (addAnotherBtn) {
            addAnotherBtn.innerHTML = '<i class="fas fa-plus"></i> Add Assignment';
        }
        
        // Keep the main form fields empty for new assignments
        const evidenceSelect = document.getElementById('evidenceSelect');
        const userSelect = document.getElementById('userSelect');
        evidenceSelect.value = '';
        userSelect.value = '';
        
        // Update the assign button state
        this.updateAssignButton();
    },
    
    // Add an existing assignment as a row
    addExistingAssignmentRow: function(assignment) {
        const container = document.getElementById('additionalAssignments');
        const rowIndex = container.children.length;
        
        const rowHTML = `
            <div class="row assignment-row" data-row="${rowIndex}">
                <div class="col-md-5">
                    <div class="mb-3">
                        <label class="form-label">Assign To</label>
                        <select class="form-select user-select">
                            <option value="">Choose user...</option>
                        </select>
                    </div>
                </div>
                <div class="col-md-5">
                    <div class="mb-3">
                        <label class="form-label">Evidence</label>
                        <select class="form-select evidence-select">
                            <option value="">Choose evidence...</option>
                        </select>
                    </div>
                </div>
                <div class="col-md-2">
                    <div class="mb-3">
                        <label class="form-label">&nbsp;</label>
                        <button type="button" class="btn btn-outline-danger btn-sm remove-row-btn" data-row="${rowIndex}">
                            <i class="fas fa-trash"></i>
                        </button>
                    </div>
                </div>
            </div>
        `;
        
        container.insertAdjacentHTML('beforeend', rowHTML);
        
        // Populate the new selects
        this.populateEvidenceSelect(container.querySelector(`[data-row="${rowIndex}"] .evidence-select`));
        this.populateUserSelect(container.querySelector(`[data-row="${rowIndex}"] .user-select`));
        
        // Set the values for this assignment
        const evidenceSelect = container.querySelector(`[data-row="${rowIndex}"] .evidence-select`);
        const userSelect = container.querySelector(`[data-row="${rowIndex}"] .user-select`);
        
        if (assignment.evidenceID) {
            evidenceSelect.value = assignment.evidenceID;
        }
        if (assignment.assignedTo) {
            userSelect.value = assignment.assignedTo;
        }
        
        // Add remove button event listener
        container.querySelector(`[data-row="${rowIndex}"] .remove-row-btn`).addEventListener('click', (e) => {
            e.target.closest('.assignment-row').remove();
            this.updateAssignButton();
        });
    },
    
    // Generate a table row for an existing assignment
    generateExistingAssignmentRow: function(assignment, index) {
        return `
            <tr data-assignment-index="${index}">
                <td>${assignment.assignedToName || 'Unknown User'}</td>
                <td>${assignment.evidenceTitle || 'Unknown Evidence'}</td>
                <td class="text-center">
                    <button type="button" class="btn btn-sm remove-existing-assignment-btn" 
                            data-project-id="${assignment.projectID}" 
                            data-safeguard-id="${assignment.safeguardID}" 
                            data-evidence-id="${assignment.evidenceID}" 
                            data-assigned-to="${assignment.assignedTo}"
                            title="Remove Assignment">
                    </button>
                </td>
            </tr>
        `;
    },
    
    // Attach event listeners for existing assignment remove buttons
    attachExistingAssignmentEventListeners: function() {
        const removeButtons = document.querySelectorAll('.remove-existing-assignment-btn');
        removeButtons.forEach(button => {
            button.addEventListener('click', (event) => {
                event.preventDefault();
                const assignment = {
                    projectID: button.getAttribute('data-project-id'),
                    safeguardID: button.getAttribute('data-safeguard-id'),
                    evidenceID: button.getAttribute('data-evidence-id'),
                    assignedTo: button.getAttribute('data-assigned-to')
                };
                this.handleRemoveExistingAssignment(assignment);
            });
        });
    },
    
    // Handle removing an existing assignment
    handleRemoveExistingAssignment: function(assignment) {
        if (confirm('Are you sure you want to remove this assignment?')) {
            this.removeAssignment(
                assignment.projectID,
                assignment.safeguardID,
                assignment.evidenceID,
                assignment.assignedTo
            );
        }
    },
    
    // Clear existing assignments from the modal
    clearExistingAssignments: function() {
        console.log('clearExistingAssignments called - stack trace:', new Error().stack);
        
        const evidenceSelect = document.getElementById('evidenceSelect');
        const userSelect = document.getElementById('userSelect');
        const additionalAssignments = document.getElementById('additionalAssignments');
        const existingSection = document.getElementById('existingAssignmentsSection');
        const existingList = document.getElementById('existingAssignmentsList');
        const mainAssignmentRow = document.getElementById('mainAssignmentRow');
        const addAnotherBtn = document.getElementById('addAnotherAssignmentBtn');
        const safeguardAssignmentForm = document.getElementById('safeguardAssignmentForm');
        const modalTitle = document.getElementById('safeguardAssignmentModalLabel');
        
        // Clear main form fields
        evidenceSelect.value = '';
        userSelect.value = '';
        
        // Clear additional assignments
        additionalAssignments.innerHTML = '';
        
        // Hide and clear existing assignments section
        existingSection.style.setProperty('display', 'none', 'important');
        existingSection.classList.remove('d-block');
        existingSection.classList.add('d-none');
        existingList.innerHTML = '';
        
        // Reset modal title to loading state
        if (modalTitle) {
            modalTitle.textContent = 'Loading...';
        }
        
        // Hide the form initially (will be shown after loading completes)
        if (safeguardAssignmentForm) {
            safeguardAssignmentForm.style.display = 'none';
        }
        
        // Hide main assignment row initially (will be shown after loading if needed)
        if (mainAssignmentRow) {
            mainAssignmentRow.style.display = 'none';
        }
        
        // Reset button text to default
        if (addAnotherBtn) {
            addAnotherBtn.innerHTML = '<i class="fas fa-plus"></i> Add Another Assignment';
        }
        
        // Update the assign button state
        this.updateAssignButton();
    },
    

    
    // Validate assignment form
    validateAssignmentForm: function() {
        let isValid = true;
        let errorMessages = [];
        
        // Clear any existing validation errors
        this.clearValidationErrors();
        
        // Validate main form fields
        const evidenceSelect = document.getElementById('evidenceSelect');
        const userSelect = document.getElementById('userSelect');
        
        const evidenceSelected = evidenceSelect.value !== '';
        const userSelected = userSelect.value !== '';
        
        if (evidenceSelected && !userSelected) {
            this.showFieldError(userSelect, 'User selection is required when evidence is selected');
            errorMessages.push('Main form: User selection is required when evidence is selected');
            isValid = false;
        } else if (!evidenceSelected && userSelected) {
            this.showFieldError(evidenceSelect, 'Evidence selection is required when user is selected');
            errorMessages.push('Main form: Evidence selection is required when user is selected');
            isValid = false;
        }
        
        // Validate additional assignment rows
        const additionalRows = document.querySelectorAll('.assignment-row');
        additionalRows.forEach((row, index) => {
            const rowEvidenceSelect = row.querySelector('.evidence-select');
            const rowUserSelect = row.querySelector('.user-select');
            
            if (rowEvidenceSelect && rowUserSelect) {
                const rowEvidenceSelected = rowEvidenceSelect.value !== '';
                const rowUserSelected = rowUserSelect.value !== '';
                
                if (rowEvidenceSelected && !rowUserSelected) {
                    this.showFieldError(rowUserSelect, 'User selection is required when evidence is selected');
                    errorMessages.push(`Row ${index + 1}: User selection is required when evidence is selected`);
                    isValid = false;
                } else if (!rowEvidenceSelected && rowUserSelected) {
                    this.showFieldError(rowEvidenceSelect, 'Evidence selection is required when user is selected');
                    errorMessages.push(`Row ${index + 1}: Evidence selection is required when user is selected`);
                    isValid = false;
                }
            }
        });
        
        if (!isValid) {
            console.error('Form validation failed:', errorMessages);
            this.showNotification('Please complete all required fields. Both evidence and user must be selected together.', 'danger');
        }
        
        return isValid;
    },
    
    // Show field validation error
    showFieldError: function(field, message) {
        // Add error class to the field
        field.classList.add('is-invalid');
        
        // Create error message element
        const errorDiv = document.createElement('div');
        errorDiv.className = 'invalid-feedback';
        errorDiv.textContent = message;
        errorDiv.style.display = 'block';
        
        // Insert error message after the field
        field.parentNode.appendChild(errorDiv);
    },
    
    // Clear all validation errors
    clearValidationErrors: function() {
        // Remove error classes from all select fields
        const allSelects = document.querySelectorAll('#safeguardAssignmentModal .form-select');
        allSelects.forEach(select => {
            select.classList.remove('is-invalid');
        });
        
        // Remove all error messages
        const errorMessages = document.querySelectorAll('#safeguardAssignmentModal .invalid-feedback');
        errorMessages.forEach(error => {
            error.remove();
        });
    },
    
    // Update assign button state
    updateAssignButton: function() {
        const evidenceSelect = document.getElementById('evidenceSelect');
        const userSelect = document.getElementById('userSelect');
        const assignBtn = document.getElementById('assignSafeguardBtn');
        
        const evidenceSelected = evidenceSelect.value !== '';
        const userSelected = userSelect.value !== '';
        
        // Check additional assignment rows
        const additionalRows = document.querySelectorAll('.assignment-row');
        let hasAdditionalSelections = false;
        
        additionalRows.forEach(row => {
            const rowEvidenceSelect = row.querySelector('.evidence-select');
            const rowUserSelect = row.querySelector('.user-select');
            
            if (rowEvidenceSelect && rowUserSelect) {
                const rowEvidenceSelected = rowEvidenceSelect.value !== '';
                const rowUserSelected = rowUserSelect.value !== '';
                
                if (rowEvidenceSelected || rowUserSelected) {
                    hasAdditionalSelections = true;
                }
            }
        });
        
        // Enable button if main form has selections OR additional rows have selections
        assignBtn.disabled = !(evidenceSelected || userSelected || hasAdditionalSelections);
    },
    
    // Add another assignment row
    addAnotherAssignmentRow: function() {
        const container = document.getElementById('additionalAssignments');
        const rowIndex = container.children.length;
        
        // Check if this is the first row being added when main row is hidden
        const mainAssignmentRow = document.getElementById('mainAssignmentRow');
        const isMainRowHidden = mainAssignmentRow && window.getComputedStyle(mainAssignmentRow).display === 'none';
        
        const rowHTML = `
            <div class="row assignment-row" data-row="${rowIndex}">
                <div class="col-md-6">
                    <div class="mb-3">
                        ${isMainRowHidden && rowIndex === 0 ? '<label class="form-label">Assign to User</label>' : ''}
                        <select class="form-select user-select">
                            <option value="">Choose user...</option>
                        </select>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="mb-3">
                        ${isMainRowHidden && rowIndex === 0 ? '<label class="form-label">Select Evidence</label>' : ''}
                        <select class="form-select evidence-select">
                            <option value="">Choose evidence...</option>
                        </select>
                    </div>
                </div>
            </div>
        `;
        
        container.insertAdjacentHTML('beforeend', rowHTML);
        
        // Populate the new selects
        this.populateEvidenceSelect(container.querySelector(`[data-row="${rowIndex}"] .evidence-select`));
        this.populateUserSelect(container.querySelector(`[data-row="${rowIndex}"] .user-select`));
        
        // Add change event listeners to update the assign button state and clear validation
        const userSelect = container.querySelector(`[data-row="${rowIndex}"] .user-select`);
        const evidenceSelect = container.querySelector(`[data-row="${rowIndex}"] .evidence-select`);
        
        userSelect.addEventListener('change', () => {
            this.clearValidationErrors();
            this.updateAssignButton();
        });
        
        evidenceSelect.addEventListener('change', () => {
            this.clearValidationErrors();
            this.updateAssignButton();
        });
    },
    
    // Populate evidence select
    populateEvidenceSelect: function(selectElement) {
        // Get current user ID from controlsData
        const currentUserId = window.controlsData.current_user_id;
        
        jQuery.ajax({
            url: window.controlsData.ajax_url,
            type: 'POST',
            data: {
                action: 'get_all_evidence_posts',
                user_id: currentUserId,
                nonce: this.getNonceForAction('get_all_evidence_posts')
            },
            success: (response) => {
                if (response.success && response.data) {
                    response.data.forEach(post => {
                        const option = document.createElement('option');
                        option.value = post.slug;
                        option.textContent = `${post.title} (${post.date})`;
                        selectElement.appendChild(option);
                    });
                }
            }
        });
    },
    
    // Populate user select
    populateUserSelect: function(selectElement) {
        // Get current user ID from controlsData
        const currentUserId = window.controlsData.current_user_id;
        
        // Get evidence ID if we're in an evidence context
        const evidenceId = this.getEvidenceIdFromContext();
        
        const requestData = {
            action: 'get_assignment_users',
            user_id: currentUserId,
            nonce: this.getNonceForAction('get_assignment_users')
        };
        
        // Add evidence_id if available
        if (evidenceId) {
            requestData.evidence_id = evidenceId;
        }
        
        jQuery.ajax({
            url: window.controlsData.ajax_url,
            type: 'POST',
            data: requestData,
            success: (response) => {
                if (response.success && response.data) {
                    response.data.forEach(user => {
                        const option = document.createElement('option');
                        option.value = user.id;
                        option.textContent = `${user.name} (${user.email})`;
                        selectElement.appendChild(option);
                    });
                }
            }
        });
    },
    
    // Assign safeguard
    assignSafeguard: function() {
        console.log('=== SAFEGUARD ASSIGNMENT DEBUG START ===');
        
        const controlId = this.currentControlId;
        const projectSlug = this.getProjectSlug();
        
        console.log('Control ID:', controlId);
        console.log('Project Slug:', projectSlug);
        console.log('Current User ID:', window.controlsData?.current_user_id);
        console.log('AJAX URL:', window.controlsData?.ajax_url);
        console.log('Nonce:', this.getNonce());
        
        if (!projectSlug) {
            console.error('Project slug is missing or undefined');
            this.showNotification('Could not determine project slug', 'danger');
            return;
        }
        
        // Validate form before proceeding
        if (!this.validateAssignmentForm()) {
            return;
        }
        
        // Get main assignment
        const evidenceSelect = document.getElementById('evidenceSelect');
        const userSelect = document.getElementById('userSelect');
        
        console.log('Evidence Select Element:', evidenceSelect);
        console.log('User Select Element:', userSelect);
        console.log('Evidence Select Value:', evidenceSelect?.value);
        console.log('User Select Value:', userSelect?.value);
        
        const assignments = [];
        
        // Add main assignment if both fields are filled
        if (evidenceSelect?.value && userSelect?.value) {
            assignments.push({
                evidenceId: evidenceSelect.value,
                assignedTo: userSelect.value
            });
            console.log('Added main assignment:', assignments[assignments.length - 1]);
        } else if (evidenceSelect?.value || userSelect?.value) {
            console.warn('Main assignment not added - only one field selected');
        } else {
            console.warn('Main assignment not added - no fields selected');
        }
        
        // Add additional assignments
        const additionalRows = document.querySelectorAll('.assignment-row');
        console.log('Additional assignment rows found:', additionalRows.length);
        
        additionalRows.forEach((row, index) => {
            const evidenceSelect = row.querySelector('.evidence-select');
            const userSelect = row.querySelector('.user-select');
            
            console.log(`Row ${index + 1} - Evidence Select:`, evidenceSelect?.value);
            console.log(`Row ${index + 1} - User Select:`, userSelect?.value);
            
            if (evidenceSelect?.value && userSelect?.value) {
                assignments.push({
                    evidenceId: evidenceSelect.value,
                    assignedTo: userSelect.value
                });
                console.log(`Added additional assignment ${index + 1}:`, assignments[assignments.length - 1]);
            } else if (evidenceSelect?.value || userSelect?.value) {
                console.warn(`Additional assignment ${index + 1} not added - only one field selected`);
            } else {
                console.warn(`Additional assignment ${index + 1} not added - no fields selected`);
            }
        });
        
        console.log('Total assignments to process:', assignments.length);
        console.log('All assignments:', assignments);
        
        if (assignments.length === 0) {
            console.error('No assignments to process');
            this.showNotification('Please select both evidence and user for at least one assignment', 'warning');
            return;
        }
        
        // Get current user ID from controlsData
        const currentUserId = window.controlsData?.current_user_id;
        
        if (!currentUserId) {
            console.error('Current user ID is missing');
            this.showNotification('User authentication error', 'danger');
            return;
        }
        
        // First, get existing assignments to check for timestamp preservation
        console.log('=== CHECKING EXISTING ASSIGNMENTS FOR TIMESTAMP PRESERVATION ===');
        this.getExistingAssignmentsForTimestampPreservation(projectSlug, controlId, assignments, currentUserId);
    },
    
    // Get existing assignments and check for timestamp preservation
    getExistingAssignmentsForTimestampPreservation: function(projectSlug, controlId, assignments, currentUserId) {
        jQuery.ajax({
            url: window.controlsData.ajax_url,
            type: 'POST',
            data: {
                action: 'safeguard_assignment',
                subaction: 'get_assignments',
                nonce: this.getNonceForAction('safeguard_assignment'),
                projectId: projectSlug,
                safeguardId: controlId
            },
            success: (response) => {
                console.log('=== EXISTING ASSIGNMENTS RETRIEVED ===');
                console.log('Existing assignments response:', response);
                
                let existingAssignments = [];
                if (response.success && response.data) {
                    existingAssignments = response.data;
                }
                
                console.log('Existing assignments:', existingAssignments);
                
                // Clean up old unassigned entries when new assigned entries are created
                const cleanedAssignments = this.cleanupOldUnassignedEntries(assignments, existingAssignments, controlId);
                
                // Process assignments with timestamp preservation
                this.processAssignmentsWithTimestampPreservation(projectSlug, controlId, cleanedAssignments, existingAssignments, currentUserId);
            },
            error: (xhr, status, error) => {
                console.error('Error getting existing assignments for timestamp preservation:', error);
                // Continue without timestamp preservation if we can't get existing assignments
                this.processAssignmentsWithTimestampPreservation(projectSlug, controlId, assignments, [], currentUserId);
            }
        });
    },
    
    // Process assignments with timestamp preservation
    processAssignmentsWithTimestampPreservation: function(projectSlug, controlId, assignments, existingAssignments, currentUserId) {
        console.log('=== PROCESSING ASSIGNMENTS WITH TIMESTAMP PRESERVATION ===');
        
        // Make assignments
        let completedAssignments = 0;
        let failedAssignments = 0;
        const assignmentResults = [];
        
        assignments.forEach((assignment, index) => {
            console.log(`--- Processing assignment ${index + 1} ---`);
            console.log('Assignment data:', assignment);
            
            // Check if this assignment already exists to preserve timestamp
            const existingAssignment = existingAssignments.find(existing => 
                existing.safeguardID === controlId && 
                existing.evidenceID === assignment.evidenceId &&
                existing.assignedTo === parseInt(assignment.assignedTo, 10)
            );
            
            console.log('Existing assignment found:', existingAssignment);
            
            const requestData = {
                action: 'safeguard_assignment',
                subaction: 'assign',
                nonce: this.getNonceForAction('safeguard_assignment'),
                projectId: projectSlug,
                safeguardId: controlId,
                evidenceId: assignment.evidenceId,
                assignedTo: assignment.assignedTo,
                userId: currentUserId
            };
            
            // Preserve timestamp if assignment already exists
            if (existingAssignment && existingAssignment.dateTime) {
                requestData.dateTime = existingAssignment.dateTime;
                console.log(`Preserving timestamp: ${existingAssignment.dateTime} (${new Date(existingAssignment.dateTime * 1000).toLocaleString()})`);
            } else {
                console.log('No existing assignment found - will use current timestamp');
            }
            
            console.log('Final request data:', requestData);
            

            
            console.log(`Sending AJAX request ${index + 1}:`, requestData);
            
            jQuery.ajax({
                url: window.controlsData.ajax_url,
                type: 'POST',
                data: requestData,
                beforeSend: function() {
                    console.log(`AJAX request ${index + 1} starting...`);
                },
                success: (response) => {
                    console.log(`AJAX request ${index + 1} success response:`, response);
                    
                    const result = {
                        index: index,
                        assignment: assignment,
                        success: response.success,
                        data: response.data,
                        message: response.data || 'No message'
                    };
                    
                    assignmentResults.push(result);
                    
                    if (response.success) {
                        completedAssignments++;
                        console.log(`Assignment ${index + 1} completed successfully`);
                    } else {
                        failedAssignments++;
                        console.error(`Assignment ${index + 1} failed:`, response.data);
                    }
                    
                    console.log(`Progress: ${completedAssignments + failedAssignments}/${assignments.length}`);
                    
                    // Check if all assignments are complete
                    if (completedAssignments + failedAssignments === assignments.length) {
                        console.log('=== ALL ASSIGNMENTS COMPLETE ===');
                        console.log('Final results:', assignmentResults);
                        console.log('Completed:', completedAssignments, 'Failed:', failedAssignments);
                        
                        if (failedAssignments === 0) {
                            this.showNotification(`Successfully assigned ${completedAssignments} safeguard assignment(s)`, 'success');
                        } else if (completedAssignments === 0) {
                            this.showNotification('Failed to assign any safeguard assignments', 'danger');
                        } else {
                            this.showNotification(`Assigned ${completedAssignments} assignment(s), ${failedAssignments} failed`, 'warning');
                        }
                        
                        // Close the modal
                        if (this.modal) {
                            this.modal.hide();
                        }
                        
                        // Reset form
                        this.resetForm();
                        
                        // Refresh assignments if on a page that shows them
                        this.refreshAssignmentsDisplay();
                    }
                },
                error: (xhr, status, error) => {
                    console.error(`AJAX request ${index + 1} error:`, {
                        status: status,
                        error: error,
                        xhr: xhr,
                        responseText: xhr.responseText,
                        statusText: xhr.statusText,
                        readyState: xhr.readyState
                    });
                    
                    const result = {
                        index: index,
                        assignment: assignment,
                        success: false,
                        error: error,
                        status: status,
                        xhr: xhr
                    };
                    
                    assignmentResults.push(result);
                    failedAssignments++;
                    
                    console.log(`Progress: ${completedAssignments + failedAssignments}/${assignments.length}`);
                    
                    // Check if all assignments are complete
                    if (completedAssignments + failedAssignments === assignments.length) {
                        console.log('=== ALL ASSIGNMENTS COMPLETE (WITH ERRORS) ===');
                        console.log('Final results:', assignmentResults);
                        console.log('Completed:', completedAssignments, 'Failed:', failedAssignments);
                        
                        this.showNotification(`Assigned ${completedAssignments} assignment(s), ${failedAssignments} failed`, 'warning');
                        
                        // Close the modal
                        if (this.modal) {
                            this.modal.hide();
                        }
                        
                        // Reset form
                        this.resetForm();
                        
                        // Refresh assignments if on a page that shows them
                        this.refreshAssignmentsDisplay();
                    }
                }
            });
        });
        
        console.log('=== SAFEGUARD ASSIGNMENT DEBUG END ===');
    },
    
    // Load assignments for a safeguard
    loadAssignments: function() {
        const controlId = this.currentControlId;
        const projectSlug = this.getProjectSlug();
        
        if (!projectSlug) {
            this.showNotification('Could not determine project slug', 'danger');
            return;
        }
        
        jQuery.ajax({
            url: window.controlsData.ajax_url,
            type: 'POST',
            data: {
                action: 'safeguard_assignment',
                subaction: 'get_assignments',
                nonce: this.getNonceForAction('safeguard_assignment'),
                projectId: projectSlug,
                safeguardId: controlId
            },
            success: (response) => {
                if (response.success && response.data) {
                    this.displayAssignments(response.data);
                } else {
                    this.displayAssignments([]);
                }
            },
            error: (xhr, status, error) => {
                console.error('AJAX error loading assignments:', error);
                this.showNotification('Error loading assignments', 'danger');
                this.displayAssignments([]);
            }
        });
    },
    
    // Display assignments in the modal
    displayAssignments: function(assignments) {
        const container = document.getElementById('assignmentsList');
        
        if (assignments.length === 0) {
            container.innerHTML = '<p class="text-muted">No assignments found for this safeguard.</p>';
            return;
        }
        
        // Function to format date with time for debugging
        function formatDate(dateString) {
            if (!dateString || dateString === 'Unknown Date') {
                return 'Unknown Date';
            }
            const date = new Date(dateString);
            if (isNaN(date.getTime())) {
                return 'Invalid Date';
            }
            return date.toLocaleDateString('en-US', {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
            }) + ' ' + date.toLocaleTimeString('en-US', {
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit'
            });
        }
        
        let html = '<div class="table-responsive"><table class="table table-striped">';
        html += '<thead><tr><th>Evidence</th><th>Assigned To</th><th>Date</th><th>Actions</th></tr></thead><tbody>';
        
        assignments.forEach(assignment => {
            html += `
                <tr>
                    <td>${assignment.evidenceID}</td>
                    <td>${assignment.assignedToName}</td>
                    <td>${formatDate(assignment.assignedDate)}</td>
                    <td>
                        <button type="button" class="btn btn-outline-danger btn-sm remove-assignment-btn" 
                                data-project-id="${assignment.projectID}" 
                                data-safeguard-id="${assignment.safeguardID}" 
                                data-evidence-id="${assignment.evidenceID}" 
                                data-assigned-to="${assignment.assignedTo}">
                            <i class="fas fa-trash"></i>
                        </button>
                    </td>
                </tr>
            `;
        });
        
        html += '</tbody></table></div>';
        container.innerHTML = html;
    },
    
    // Remove an assignment
    removeAssignment: function(projectId, safeguardId, evidenceId, assignedTo) {
        console.log('=== REMOVE ASSIGNMENT CALLED ===');
        console.log('Parameters:', {
            projectId: projectId,
            safeguardId: safeguardId,
            evidenceId: evidenceId,
            assignedTo: assignedTo
        });
        
        // Get AJAX URL from available data sources
        const ajaxUrl = window.controlsData?.ajax_url || window.evidenceData?.ajax_url;
        
        console.log('AJAX URL:', ajaxUrl);
        
        if (!ajaxUrl) {
            console.error('No AJAX URL found for removeAssignment');
            this.showNotification('Error: AJAX URL not available', 'danger');
            return;
        }
        
        const requestData = {
            action: 'safeguard_assignment',
            subaction: 'remove_assignment',
            nonce: this.getNonceForAction('safeguard_assignment'),
            projectId: projectId,
            safeguardId: safeguardId,
            evidenceId: evidenceId,
            assignedTo: assignedTo
        };
        
        console.log('Request data:', requestData);
        
        jQuery.ajax({
            url: ajaxUrl,
            type: 'POST',
            data: requestData,
            success: (response) => {
                console.log('Remove assignment response:', response);
                if (response.success) {
                    // Only show notification for non-dummy assignments
                    if (safeguardId !== 'PROJECT_ASSOCIATION_ONLY') {
                        this.showNotification('Assignment(s) updated successfully', 'success');
                        
                        // Check if we need to create a dummy assignment to maintain project association
                        this.checkAndCreateDummyAssignment(projectId, evidenceId, () => {
                            // Reload the page to refresh the display
                            setTimeout(() => {
                                window.location.reload();
                            }, 1000); // Wait 1 second to show the success message
                        });
                    } else {
                        // For dummy assignments, just reload without notification
                        console.log('Dummy assignment removed silently');
                        window.location.reload();
                    }
                } else {
                    this.showNotification('Failed to remove assignment', 'danger');
                }
            },
            error: (xhr, status, error) => {
                console.error('AJAX error removing assignment:', error);
                this.showNotification('Error removing assignment', 'danger');
            }
        });
    },
    
    // Refresh assignments display on the page
    refreshAssignmentsDisplay: function() {
        // Trigger a custom event that other components can listen to
        document.dispatchEvent(new CustomEvent('assignmentsUpdated'));
    },
    
    // Get project slug from the current page
    getProjectSlug: function() {
        // If we have a specific project ID set (from evidence page), use that
        if (this.currentProjectId) {
            return this.currentProjectId;
        }
        
        // First try to get the project slug from the page URL or data attributes
        const projectSlugElement = document.querySelector('[data-project-slug]');
        if (projectSlugElement) {
            return projectSlugElement.getAttribute('data-project-slug');
        }
        
        // Try to get from URL path
        const pathSegments = window.location.pathname.split('/');
        for (let i = 0; i < pathSegments.length; i++) {
            if (pathSegments[i] && pathSegments[i] !== 'projects' && pathSegments[i] !== '') {
                // This might be the project slug
                return pathSegments[i];
            }
        }
        
        // Fallback: try to get from body classes or other sources
        const bodyClasses = document.body.className.split(' ');
        for (let className of bodyClasses) {
            if (className.startsWith('project-')) {
                return className.replace('project-', '');
            }
        }
        
        // If we can't find the slug, we'll need to make an AJAX call to get it from the post ID
        const postId = this.getPostId();
        if (postId) {
            return this.getProjectSlugFromPostId(postId);
        }
        
        return null;
    },
    
    // Get post ID from the current page
    getPostId: function() {
        // Use the existing getPostIdFromBodyClass function
        if (typeof window.getPostIdFromBodyClass === 'function') {
            return window.getPostIdFromBodyClass();
        }
        
        // Fallback: try to get from body classes
        const bodyClasses = document.body.className.split(' ');
        for (let className of bodyClasses) {
            if (className.startsWith('postid-')) {
                return className.replace('postid-', '');
            }
        }
        
        // Fallback: try to get from URL or other sources
        const urlParams = new URLSearchParams(window.location.search);
        const projectId = urlParams.get('project_id') || urlParams.get('p');
        
        return projectId;
    },
    
    // Get project slug from post ID via AJAX
    getProjectSlugFromPostId: function(postId) {
        // For now, return null and let the backend handle the conversion
        // This is a temporary solution - ideally we'd make an AJAX call to get the slug
        console.warn('Could not determine project slug from post ID:', postId);
        return null;
    },
    
    // Reset the form
    resetForm: function() {
        this.clearExistingAssignments();
    },
    
    // Show notification to user
    showNotification: function(message, type = 'info') {
        // Create a simple notification element
        const notification = document.createElement('div');
        notification.className = `alert alert-${type} alert-dismissible fade show`;
        notification.style.position = 'fixed';
        notification.style.top = '20px';
        notification.style.right = '20px';
        notification.style.zIndex = '9999';
        notification.innerHTML = `
            ${message}
            <button type="button" class="btn-close" data-bs-dismiss="alert"></button>
        `;
        
        document.body.appendChild(notification);
        
        // Auto-remove after 5 seconds
        setTimeout(() => {
            if (notification.parentNode) {
                notification.parentNode.removeChild(notification);
            }
        }, 5000);
    },
    
    // Add necessary styles for the safeguard assignment functionality
    addStyles: function() {
        // Styles are now included in the main CSS file
        // This function is kept for potential future dynamic style additions
        console.log('Safeguard assignment styles loaded from CSS file');
    },
    
    // Helper function to remove all assignments for a project/evidence combination
    removeAllAssignmentsForProject: function(projectId, evidenceId, callback) {
        console.log('removeAllAssignmentsForProject: Removing assignments for project:', projectId, 'evidence:', evidenceId);
        
        // Get the correct AJAX URL based on available data
        const ajaxUrl = window.controlsData?.ajax_url || window.evidenceData?.ajax_url;
        if (!ajaxUrl) {
            console.error('removeAllAssignmentsForProject: No AJAX URL found');
            if (callback) callback();
            return;
        }
        
        // First, get all existing assignments for this project/evidence
        jQuery.ajax({
            url: ajaxUrl,
            type: 'POST',
            data: {
                action: 'safeguard_assignment',
                subaction: 'get_evidence_assignments',
                evidence_id: evidenceId,
                nonce: this.getNonceForAction('safeguard_assignment')
            },
            success: (response) => {
                if (response.success && response.data) {
                    const assignments = response.data.filter(assignment => assignment.projectID === projectId);
                    console.log('removeAllAssignmentsForProject: Found assignments to remove:', assignments);
                    
                    if (assignments.length === 0) {
                        console.log('removeAllAssignmentsForProject: No assignments to remove');
                        if (callback) callback();
                        return;
                    }
                    
                    // Remove each assignment
                    let completedRemovals = 0;
                    let failedRemovals = 0;
                    
                    assignments.forEach((assignment, index) => {
                        jQuery.ajax({
                            url: window.controlsData.ajax_url,
                            type: 'POST',
                            data: {
                                action: 'safeguard_assignment',
                                subaction: 'remove_assignment',
                                nonce: this.getNonceForAction('safeguard_assignment'),
                                projectId: assignment.projectID,
                                safeguardId: assignment.safeguardID,
                                evidenceId: assignment.evidenceID,
                                assignedTo: assignment.assignedTo
                            },
                            success: (response) => {
                                completedRemovals++;
                                console.log(`removeAllAssignmentsForProject: Removed assignment ${index + 1}/${assignments.length}`);
                                
                                if (completedRemovals + failedRemovals === assignments.length) {
                                    console.log('removeAllAssignmentsForProject: All removals complete');
                                    if (callback) callback();
                                }
                            },
                            error: (xhr, status, error) => {
                                failedRemovals++;
                                console.error(`removeAllAssignmentsForProject: Failed to remove assignment ${index + 1}:`, error);
                                
                                if (completedRemovals + failedRemovals === assignments.length) {
                                    console.log('removeAllAssignmentsForProject: All removals complete (with errors)');
                                    if (callback) callback();
                                }
                            }
                        });
                    });
                } else {
                    console.log('removeAllAssignmentsForProject: No assignments found');
                    if (callback) callback();
                }
            },
            error: (xhr, status, error) => {
                console.error('removeAllAssignmentsForProject: Error getting assignments:', error);
                if (callback) callback();
            }
        });
    },
    
    // Helper function to create multiple assignments
    createMultipleAssignments: function(assignments, callback) {
        console.log('createMultipleAssignments: Creating assignments:', assignments);
        
        if (assignments.length === 0) {
            console.log('createMultipleAssignments: No assignments to create');
            if (callback) callback(true);
            return;
        }
        
        // Get current user ID (optional for unassigned safeguards)
        const currentUserId = window.controlsData?.current_user_id || window.evidenceData?.current_user_id;
        
        let completedAssignments = 0;
        let failedAssignments = 0;
        
        // Get the correct AJAX URL based on available data
        const ajaxUrl = window.controlsData?.ajax_url || window.evidenceData?.ajax_url;
        if (!ajaxUrl) {
            console.error('createMultipleAssignments: No AJAX URL found');
            if (callback) callback(false);
            return;
        }
        
        assignments.forEach((assignment, index) => {
            console.log(`=== DEBUG: createMultipleAssignments - Assignment ${index + 1} ===`);
            console.log('Original assignment data:', assignment);
            console.log('dateTime value:', assignment.dateTime);
            console.log('dateTime type:', typeof assignment.dateTime);
            
            // Prepare the data object
            const requestData = {
                action: 'safeguard_assignment',
                subaction: 'assign',
                nonce: this.getNonceForAction('safeguard_assignment'),
                projectId: assignment.projectId,
                safeguardId: assignment.safeguardId,
                evidenceId: assignment.evidenceId
            };
            
            // Only add assignedTo if it's not null
            if (assignment.assignedTo !== null && assignment.assignedTo !== undefined) {
                requestData.assignedTo = assignment.assignedTo;
            }
            
            // Only add dateTime if it's provided (for preserving original assignment date)
            if (assignment.dateTime !== null && assignment.dateTime !== undefined) {
                requestData.dateTime = assignment.dateTime;
                console.log(`Adding dateTime to request: ${assignment.dateTime} (${new Date(assignment.dateTime * 1000).toLocaleString()})`);
            } else {
                console.log('No dateTime provided - will use current timestamp');
            }
            
            // Only add userId if currentUserId exists
            if (currentUserId) {
                requestData.userId = currentUserId;
            }
            
            console.log('Final request data:', requestData);
            
            jQuery.ajax({
                url: ajaxUrl,
                type: 'POST',
                data: requestData,
                success: (response) => {
                    completedAssignments++;
                    console.log(`createMultipleAssignments: Created assignment ${index + 1}/${assignments.length}`);
                    
                    if (completedAssignments + failedAssignments === assignments.length) {
                        console.log('createMultipleAssignments: All assignments complete');
                        const success = failedAssignments === 0;
                        if (callback) callback(success);
                    }
                },
                error: (xhr, status, error) => {
                    failedAssignments++;
                    console.error(`createMultipleAssignments: Failed to create assignment ${index + 1}:`, error);
                    
                    if (completedAssignments + failedAssignments === assignments.length) {
                        console.log('createMultipleAssignments: All assignments complete (with errors)');
                        const success = failedAssignments === 0;
                        if (callback) callback(success);
                    }
                }
            });
        });
    },

    // Clean up old unassigned entries when new assigned entries are created
    cleanupOldUnassignedEntries: function(newAssignments, existingAssignments, safeguardId) {
        console.log('=== CLEANUP: Starting unassigned entry cleanup for assessment page ===');
        console.log('New assignments:', newAssignments);
        console.log('Existing assignments:', existingAssignments);
        console.log('Safeguard ID:', safeguardId);
        
        const cleanedAssignments = [...newAssignments];
        
        // Check if we have any new assigned entries (assignedTo is not null/empty)
        const hasNewAssignedEntries = newAssignments.some(assignment => 
            assignment.assignedTo && assignment.assignedTo !== '' && assignment.assignedTo !== null
        );
        
        if (hasNewAssignedEntries) {
            console.log(`CLEANUP: Safeguard ${safeguardId} has new assigned entries, checking for old unassigned entries`);
            
            // Find existing unassigned entries for this safeguard
            const existingUnassignedEntries = existingAssignments.filter(existing => 
                existing.safeguardID === safeguardId && 
                (existing.assignedTo === null || existing.assignedTo === undefined || existing.assignedToName === 'Unassigned')
            );
            
            console.log(`CLEANUP: Found ${existingUnassignedEntries.length} existing unassigned entries for safeguard ${safeguardId}:`, existingUnassignedEntries);
            
            // Find new unassigned entries for this safeguard
            const newUnassignedEntries = newAssignments.filter(assignment => 
                !assignment.assignedTo || assignment.assignedTo === '' || assignment.assignedTo === null
            );
            
            console.log(`CLEANUP: Found ${newUnassignedEntries.length} new unassigned entries for safeguard ${safeguardId}:`, newUnassignedEntries);
            
            // If we have new assigned entries AND new unassigned entries, remove the new unassigned entries
            // (because the assigned entries are more recent and take precedence)
            if (newUnassignedEntries.length > 0) {
                console.log(`CLEANUP: Removing ${newUnassignedEntries.length} new unassigned entries for safeguard ${safeguardId} because assigned entries exist`);
                
                // Remove new unassigned entries from the cleaned assignments
                newUnassignedEntries.forEach(unassignedEntry => {
                    const index = cleanedAssignments.findIndex(assignment => 
                        assignment.evidenceId === unassignedEntry.evidenceId &&
                        (!assignment.assignedTo || assignment.assignedTo === '' || assignment.assignedTo === null)
                    );
                    
                    if (index !== -1) {
                        console.log(`CLEANUP: Removing unassigned entry at index ${index}:`, cleanedAssignments[index]);
                        cleanedAssignments.splice(index, 1);
                    }
                });
            }
            
            // Also remove existing unassigned entries if they're older than the new assigned entries
            if (existingUnassignedEntries.length > 0) {
                console.log(`CLEANUP: Checking if existing unassigned entries should be removed for safeguard ${safeguardId}`);
                
                // Get the newest assigned entry timestamp for this safeguard
                const assignedEntries = newAssignments.filter(assignment => 
                    assignment.assignedTo && assignment.assignedTo !== '' && assignment.assignedTo !== null
                );
                
                if (assignedEntries.length > 0) {
                    // Find the most recent assigned entry (highest dateTime or current timestamp)
                    const newestAssignedEntry = assignedEntries.reduce((newest, current) => {
                        const currentTime = current.dateTime || Math.floor(Date.now() / 1000);
                        const newestTime = newest.dateTime || Math.floor(Date.now() / 1000);
                        return currentTime > newestTime ? current : newest;
                    });
                    
                    console.log(`CLEANUP: Newest assigned entry for safeguard ${safeguardId}:`, newestAssignedEntry);
                    
                    // Remove existing unassigned entries that are older than the newest assigned entry
                    existingUnassignedEntries.forEach(existingUnassigned => {
                        const existingTime = existingUnassigned.dateTime || 0;
                        const newestTime = newestAssignedEntry.dateTime || Math.floor(Date.now() / 1000);
                        
                        console.log(`CLEANUP: Comparing existing unassigned (${existingTime}) vs newest assigned (${newestTime})`);
                        
                        if (existingTime < newestTime) {
                            console.log(`CLEANUP: Existing unassigned entry is older, will be removed by individual assignment processing`);
                            // Note: The existing unassigned entry will be removed by the individual assignment processing
                            // We don't need to do anything special here since each assignment is processed individually
                        } else {
                            console.log(`CLEANUP: Existing unassigned entry is newer or same age, keeping it`);
                        }
                    });
                }
            }
        }
        
        console.log('=== CLEANUP: Final cleaned assignments for assessment page ===');
        console.log('Original assignments count:', newAssignments.length);
        console.log('Cleaned assignments count:', cleanedAssignments.length);
        console.log('Cleaned assignments:', cleanedAssignments);
        
        return cleanedAssignments;
    },

    // Helper function to update an existing assignment
    updateAssignment: function(assignmentId, assignmentData, callback) {
        console.log('updateAssignment: Updating assignment:', assignmentId, assignmentData);
        
        // Get the correct AJAX URL based on available data
        const ajaxUrl = window.controlsData?.ajax_url || window.evidenceData?.ajax_url;
        if (!ajaxUrl) {
            console.error('updateAssignment: No AJAX URL found');
            if (callback) callback(false);
            return;
        }
        
        // Get nonce for the action
        const nonce = this.getNonceForAction('safeguard_assignment');
        if (!nonce) {
            console.error('updateAssignment: No nonce found');
            if (callback) callback(false);
            return;
        }
        
        const requestData = {
            action: 'safeguard_assignment',
            subaction: 'update',
            nonce: nonce,
            assignmentId: assignmentId,
            projectId: assignmentData.projectId,
            safeguardId: assignmentData.safeguardId,
            evidenceId: assignmentData.evidenceId,
            assignedBy: assignmentData.assignedBy
        };
        
        // Only add assignedTo if it's not null
        if (assignmentData.assignedTo !== null && assignmentData.assignedTo !== undefined) {
            requestData.assignedTo = assignmentData.assignedTo;
        }
        
        // Only add dateTime if it's provided
        if (assignmentData.dateTime !== null && assignmentData.dateTime !== undefined) {
            requestData.dateTime = assignmentData.dateTime;
        }
        
        console.log('updateAssignment: Request data:', requestData);
        
        jQuery.ajax({
            url: ajaxUrl,
            type: 'POST',
            data: requestData,
            success: (response) => {
                console.log('updateAssignment: Success response:', response);
                if (response.success) {
                    console.log('updateAssignment: Assignment updated successfully');
                    if (callback) callback(true);
                } else {
                    console.error('updateAssignment: Failed to update assignment:', response.data);
                    if (callback) callback(false);
                }
            },
            error: (xhr, status, error) => {
                console.error('updateAssignment: AJAX error:', error);
                if (callback) callback(false);
            }
        });
    },

    // Check if we need to create a dummy assignment to maintain project association
    checkAndCreateDummyAssignment: function(projectId, evidenceId, callback) {
        console.log('checkAndCreateDummyAssignment: Checking if dummy assignment needed for project:', projectId, 'evidence:', evidenceId);
        
        // Get the correct AJAX URL based on available data
        const ajaxUrl = window.controlsData?.ajax_url || window.evidenceData?.ajax_url;
        if (!ajaxUrl) {
            console.error('checkAndCreateDummyAssignment: No AJAX URL found');
            if (callback) callback();
            return;
        }
        
        // Get nonce for the action
        const nonce = this.getNonceForAction('safeguard_assignment');
        if (!nonce) {
            console.error('checkAndCreateDummyAssignment: No nonce found');
            if (callback) callback();
            return;
        }
        
        // First, get all existing assignments for this project and evidence
        jQuery.ajax({
            url: ajaxUrl,
            type: 'POST',
            data: {
                action: 'safeguard_assignment',
                subaction: 'get_evidence_assignments',
                evidence_id: evidenceId,
                nonce: nonce
            },
            success: (response) => {
                if (response.success && response.data) {
                    // Filter assignments for this specific project
                    const projectAssignments = response.data.filter(assignment => 
                        assignment.projectID === projectId
                    );
                    
                    console.log('checkAndCreateDummyAssignment: Found assignments for project:', projectAssignments);
                    
                    // Check if there are any real assignments (non-dummy) for this project
                    const realAssignments = projectAssignments.filter(assignment => 
                        assignment.safeguardID !== 'PROJECT_ASSOCIATION_ONLY'
                    );
                    
                    console.log('checkAndCreateDummyAssignment: Real assignments count:', realAssignments.length);
                    
                    // If no real assignments exist, create a dummy assignment
                    if (realAssignments.length === 0) {
                        console.log('checkAndCreateDummyAssignment: No real assignments found, creating dummy assignment');
                        
                        // Get current user ID
                        const currentUserId = window.controlsData?.current_user_id || window.evidenceData?.current_user_id;
                        
                        const dummyAssignment = {
                            projectId: projectId,
                            safeguardId: 'PROJECT_ASSOCIATION_ONLY',
                            evidenceId: evidenceId,
                            assignedTo: null,
                            assignedBy: currentUserId
                        };
                        
                        console.log('checkAndCreateDummyAssignment: Creating dummy assignment:', dummyAssignment);
                        
                        // Create the dummy assignment silently
                        this.createMultipleAssignments([dummyAssignment], function(success) {
                            console.log('checkAndCreateDummyAssignment: Dummy assignment created:', success ? 'SUCCESS' : 'FAILED');
                            if (callback) callback();
                        });
                    } else {
                        console.log('checkAndCreateDummyAssignment: Real assignments still exist, no dummy needed');
                        if (callback) callback();
                    }
                } else {
                    console.log('checkAndCreateDummyAssignment: No assignments found for evidence');
                    if (callback) callback();
                }
            },
            error: (xhr, status, error) => {
                console.error('checkAndCreateDummyAssignment: Error getting assignments:', error);
                if (callback) callback();
            }
        });
    },

    // Helper function to remove all assignments for a specific project and evidence combination
    removeProjectAssignments: function(projectId, evidenceId, callback) {
        console.log('removeProjectAssignments: Removing all assignments for project:', projectId, 'evidence:', evidenceId);
        
        // Get the correct AJAX URL based on available data
        const ajaxUrl = window.controlsData?.ajax_url || window.evidenceData?.ajax_url;
        if (!ajaxUrl) {
            console.error('removeProjectAssignments: No AJAX URL found');
            if (callback) callback(false);
            return;
        }
        
        // Get nonce for the action
        const nonce = this.getNonceForAction('safeguard_assignment');
        if (!nonce) {
            console.error('removeProjectAssignments: No nonce found');
            if (callback) callback(false);
            return;
        }
        
        // First, get all existing assignments for this project and evidence
        jQuery.ajax({
            url: ajaxUrl,
            type: 'POST',
            data: {
                action: 'safeguard_assignment',
                subaction: 'get_evidence_assignments',
                evidence_id: evidenceId,
                nonce: nonce
            },
            success: (response) => {
                if (response.success && response.data) {
                    // Filter assignments for this specific project
                    const projectAssignments = response.data.filter(assignment => 
                        assignment.projectID === projectId
                    );
                    
                    console.log('removeProjectAssignments: Found assignments to remove:', projectAssignments);
                    
                    if (projectAssignments.length === 0) {
                        console.log('removeProjectAssignments: No assignments found to remove');
                        if (callback) callback(true);
                        return;
                    }
                    
                    let completedRemovals = 0;
                    let failedRemovals = 0;
                    
                    // Remove each assignment
                    projectAssignments.forEach((assignment, index) => {
                        console.log(`removeProjectAssignments: Removing assignment ${index + 1}:`, assignment);
                        
                        jQuery.ajax({
                            url: ajaxUrl,
                            type: 'POST',
                            data: {
                                action: 'safeguard_assignment',
                                subaction: 'remove_assignment',
                                nonce: nonce,
                                projectId: assignment.projectID,
                                safeguardId: assignment.safeguardID,
                                evidenceId: assignment.evidenceID,
                                assignedTo: assignment.assignedTo
                            },
                            success: (removeResponse) => {
                                completedRemovals++;
                                console.log(`removeProjectAssignments: Removed assignment ${index + 1}/${projectAssignments.length}`);
                                
                                if (completedRemovals + failedRemovals === projectAssignments.length) {
                                    console.log('removeProjectAssignments: All removals complete');
                                    const success = failedRemovals === 0;
                                    if (callback) callback(success);
                                }
                            },
                            error: (xhr, status, error) => {
                                failedRemovals++;
                                console.error(`removeProjectAssignments: Failed to remove assignment ${index + 1}:`, error);
                                
                                if (completedRemovals + failedRemovals === projectAssignments.length) {
                                    console.log('removeProjectAssignments: All removals complete (with errors)');
                                    const success = failedRemovals === 0;
                                    if (callback) callback(success);
                                }
                            }
                        });
                    });
                } else {
                    console.log('removeProjectAssignments: No assignments found');
                    if (callback) callback(true);
                }
            },
            error: (xhr, status, error) => {
                console.error('removeProjectAssignments: Error getting assignments:', error);
                if (callback) callback(false);
            }
        });
    },
    
    // Get evidence ID from current context
    getEvidenceIdFromContext: function() {
        // Check if we're on an evidence page by looking for evidence-specific elements
        if (typeof getPostIdFromBodyClass === 'function') {
            return getPostIdFromBodyClass();
        }
        
        // Fallback: check for evidence-specific classes or data attributes
        const evidenceElements = document.querySelectorAll('[data-evidence-id], .evidence-page, .single-evidence');
        if (evidenceElements.length > 0) {
            // Try to get evidence ID from data attributes or URL
            const evidenceElement = evidenceElements[0];
            if (evidenceElement.dataset.evidenceId) {
                return evidenceElement.dataset.evidenceId;
            }
        }
        
        // Check URL for evidence slug
        const urlPath = window.location.pathname;
        const evidenceMatch = urlPath.match(/\/evidence\/([^\/]+)/);
        if (evidenceMatch) {
            return evidenceMatch[1];
        }
        
        return null;
    }
};

// Auto-initialize when DOM is ready
document.addEventListener('DOMContentLoaded', function() {
    window.safeguardAssignment.init();
});

// Also initialize when controls are dynamically added
document.addEventListener('controlsAppended', function() {
    window.safeguardAssignment.init();
});

